import { render } from "./no-tech.vue?vue&type=template&id=07fa5a7e"
import script from "./no-tech.vue?vue&type=script&lang=js"
export * from "./no-tech.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__